define(function (require, exports, module) {
    'use strict';

    const removeHtml = require('../tools/string/removeHtml');
    const UploadError = require('./UploadError');
    const { HttpErrorCodes } = require('reactApp/api/HttpErrorCodes');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     * @param {number} status
     * @param {string} responseText
     */
    function HttpError(stack, source, status, responseText) {
        UploadError.apply(this, arguments);

        this.message = this.message.replace('{STATUS}', status);
        this.radarName = this.radarName.replace('{STATUS}', status);
        this.responseText = removeHtml(responseText).trim().slice(0, 1000);
        this.status = status;
    }

    Object.assign(HttpError, HttpErrorCodes);

    HttpError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: HttpError,
        className: 'HttpError',
        radarName: 'error_{SOURCE}_http-{STATUS}',
        message: 'Ошибка HTTP {STATUS}',
        responseText: '',
        status: -1,

        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME} { {META} }: {STATUS} – {RESPONSE_TEXT}',

        toLogString: function () {
            var result = UploadError.prototype.toLogString.apply(this, arguments);

            result = result.replace('{STATUS}', this.status);
            result = result.replace('{RESPONSE_TEXT}', this.responseText);

            return result;
        },

        getDetails: function () {
            var details = UploadError.prototype.getDetails.apply(this, arguments);

            details.status = this.status;
            details.responseText = this.responseText;

            return details;
        },
    });

    module.exports = HttpError;
});
